//CKAPISIZ;452643;10042025;
export interface GeneralItem {
  id: number;
  name: string;
  note: string;
  disease_type: string;
  special_notes: string;
}

export interface HabitsItem {
  id: number;
  type_if_substance: string;
  quantity_per_day: string;
  duration_in_years: string;
  quit_date: string;
}

export interface OtherItem {
  id: number;
  disease_with_date: string;
  surgery_institution: string;
  edit: string;
}

export interface GeneralHealthInfoCategory {
  id: number;
  category: string;
  expanded: boolean;
  generalItem: GeneralItem[];
  habitsItem: HabitsItem[];
  otherItem: OtherItem[];
}

export const GeneralHealthInfoData: GeneralHealthInfoCategory[] = [
  {
    id: 1,
    category: "Alerjiler",
    expanded: false,
    generalItem: [
      {
        id: 1,
        name: "Kuru Baklagiller",
        note: "Olası",
        disease_type: "Alerji",
        special_notes: "Dikkat edilmeli",
      },
      {
        id: 2,
        name: "Yoğurt",
        note: "Kesin",
        disease_type: "Alerji",
        special_notes: "Kullanılmamalı",
      },
    ],
    habitsItem: [],
    otherItem: [],
  },
  {
    id: 2,
    category: "Alışkanlıklar",
    expanded: false,
    generalItem: [],
    habitsItem: [
      {
        id: 1,
        type_if_substance: "Sigara",
        quantity_per_day: "20",
        duration_in_years: "5",
        quit_date: "2025-06-01",
      },
      {
        id: 2,
        type_if_substance: "Alkol",
        quantity_per_day: "2",
        duration_in_years: "10",
        quit_date: "2025-06-01",
      },
    ],
    otherItem: [],
  },
  {
    id: 3,
    category: "Soy Geçmiş",
    expanded: false,
    generalItem: [
      {
        id: 3,
        name: "Genetik Hastalıklar",
        note: "Ailevi",
        disease_type: "Geçmiş",
        special_notes: "Dikkat edilmesi gerekir",
      },
    ],
    habitsItem: [],
    otherItem: [],
  },
  {
    id: 4,
    category: "Geçirilmiş Hastalıklar",
    expanded: false,
    generalItem: [
      {
        id: 4,
        name: "Diyabet",
        note: "İleri düzey",
        disease_type: "Hastalık",
        special_notes: "İlaç kullanımı gerekli",
      },
    ],
    habitsItem: [],
    otherItem: [],
  },
  {
    id: 5,
    category: "Geçirilmiş Ameliyatlar",
    expanded: false,
    generalItem: [
      {
        id: 5,
        name: "Kalp Ameliyatı",
        note: "Başarılı",
        disease_type: "Ameliyat",
        special_notes: "Takip edilmeli",
      },
    ],
    habitsItem: [],
    otherItem: [],
  },
  {
    id: 6,
    category: "Özel Notlar",
    expanded: false,
    generalItem: [
      {
        id: 6,
        name: "Yaşam Tarzı",
        note: "Dikkat edilmesi gereken",
        disease_type: "Özel",
        special_notes: "Sağlıklı beslenme",
      },
    ],
    habitsItem: [],
    otherItem: [],
  },
];
